import { render, staticRenderFns } from "./PsotEdit.vue?vue&type=template&id=2c22c0c6&scoped=true&"
import script from "./PsotEdit.vue?vue&type=script&lang=js&"
export * from "./PsotEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22c0c6",
  null
  
)

export default component.exports